Enterscenarioid
<input type="number" class="form-control" [(ngModel)]="id">
<button class="btn-primary" (click)="submit()">Submit</button>
